import type { InventoryInformationEditView, InventoryInformationView } from "@slfinrtl/ui-bff-routes"
import { FormProvider, useForm } from "react-hook-form"
import type { InventoryInformationFormValues } from "src/components"
import { mapToInventoryInformationFormValues } from "src/components"
import { PricingDataFormContainer } from "./PricingDataFormContainer"

interface PricingFormContainerProps {
	inventoryId: string
	onCancel: () => void
	onSaved: (view: InventoryInformationView) => void
	view: InventoryInformationEditView
}

export const PricingFormContainer = ({ inventoryId, onCancel, onSaved, view }: PricingFormContainerProps) => {
	const form = useForm<InventoryInformationFormValues>({
		defaultValues: mapToInventoryInformationFormValues(view.values),
		mode: "onChange",
	})

	return (
		<FormProvider {...form}>
			<PricingDataFormContainer inventoryId={inventoryId} view={view} onCancel={onCancel} onSaved={onSaved} />
		</FormProvider>
	)
}
